import { defineMessage } from 'services/localization';

export const messages = {
    poDateFieldText: defineMessage('date'),
    poDeliveryDateFieldText: defineMessage('delivery_date_1'),
    poNumberFieldText: defineMessage('order_number'),
    poReferenceFieldText: defineMessage('reference'),
    poBrandingThemeFieldText: defineMessage('theme'),
    emptyPurchaseOrderNumber: defineMessage('allocated_on_approval'),
};
